import { Login } from "react-admin";
import wall from '../assets/img/wall4.jpg';

export const LoginPage = () => (
    <Login
        backgroundImage={wall}
    />
  );